import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './EventPanel.css';
import { NavigatorStore } from '../stores';
import { IAEvent } from '../../event';
// import NavigationBar from '../../panels/navigationBar/NavigationBar';
import { Helper } from '../../../Helper';
import InstanceService from '../../../services/InstanceService';
import { INavigatorContentFromLink } from '../../../interfaces/INavigatorContentFromLink';
import { TargetingService } from '../../../services/TargetingService';
import UserService from '../../../services/UserService';
import { Environment } from '../../../services/Environment';
import { IUserRole } from '../../../interfaces/IUserRole';
import { IInstance } from '../../../interfaces/IInstance';
import { IHttpStatus } from '../../../interfaces/IHttpStatus';
import { ITargetingProperties } from '../../../interfaces/ITargetingProperties';

export interface IProps {
  navigatorStore?: NavigatorStore;
  isShowing?: boolean;
}

export interface IState {
  instance: IInstance;
  eventToOpenSettings: INavigatorContentFromLink;
}

@inject('navigatorStore')
@observer
export default class EventPanel extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      instance: null,
      eventToOpenSettings: null
    };
  }

  public componentDidMount(): void {
    window.addEventListener('popstate', () => this.openEventFromUrl());
    this.openEventFromUrl();
  }

  private openEventFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const instanceName = urlParams.get('instance');
    const eventId = urlParams.get('eventId');

    if (!instanceName || !eventId) {
      this.setState({
        instance: null,
        eventToOpenSettings: null
      });
      return;
    }

    InstanceService.getInstanceIdByName(
      this.props.navigatorStore.environment,
      this.props.navigatorStore.token,
      this.props.navigatorStore.tenant,
      "IntraActive-Events",
      instanceName,
      false
    ).then(instance => {
      instance.instanceName = instance.instanceName ?? "Default";
      this.setState({ instance: instance });
      if (eventId) {
        let eventToOpenSettings: INavigatorContentFromLink = {};
        eventToOpenSettings.openedFromLink = true;
        eventToOpenSettings.component = "Events";
        eventToOpenSettings.idToOpen = parseInt(eventId);
        // Targeting
        TargetingService.getTargetingApplication(this.props.navigatorStore.environment, this.props.navigatorStore.tenant, this.props.navigatorStore.token, eventToOpenSettings.component).then((targetingApplications) => {
          eventToOpenSettings.targetingApplications = targetingApplications;
          TargetingService.getProperties(this.props.navigatorStore.environment, this.props.navigatorStore.tenant.replace(".sharepoint.com", ""), this.props.navigatorStore.token).then((response: { httpStatus: IHttpStatus, value?: ITargetingProperties[] }) => {
            eventToOpenSettings.targetingProperties = response.value;
            // User role
            UserService.getUserRole(Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment), this.props.navigatorStore.tenant, instance?.id, this.props.navigatorStore.token, "IntraActive-Events").then((userRole: IUserRole) => {
              eventToOpenSettings.userRole = userRole;
              this.setState({ eventToOpenSettings });
            });
          });
        });
      }
    });
  }

  render() {
    let height: number = this.props.navigatorStore.contentHeight;
    let position = {};
    if (this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.navigator.design.menuBar.layout == "vertical") {
      let left = 0;
      if (this.props.navigatorStore.verticalMenuExpanded) {
        left = this.props.navigatorStore.selectedEvent != undefined ? 250 : -600;
      } else {
        left = this.props.navigatorStore.selectedEvent != undefined ? 0 : -600;
      }
      position = {
        left: left
      }
    } else {
      position = {
        right: this.props.navigatorStore.selectedEvent != undefined ? 0 : -600
      }
    }
    let top = 40;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") != undefined && document.getElementById("IA_navigator_vertical_menu") == undefined) {
      top = 88;
    }
    return (
      <div id="event">
        <div className={styles.containerOverlay}
          style={{
            display: this.props.navigatorStore.selectedEvent ? "block" : "none",
          }}
          onClick={() => {
            this.props.navigatorStore.selectedEvent = undefined;
            this.props.navigatorStore.selectTopMenuItem(undefined);
            document.body.style.overflowY = "auto";
            document.body.style.height = "inherit";
          }}
        />
        <div className={styles.container} id="eventContainer"
          style={{
            top: top,
            height: height,
            opacity: this.props.navigatorStore.selectedEvent || this.state.eventToOpenSettings ? 1 : 0,
            width: this.props.navigatorStore.isMobile ? "100%" : 600,
            ...position
          }}
        >
          <div className={styles.eventContainer}>
            {this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.selectedEvent &&
              <IAEvent
                environment={this.props.navigatorStore.environment}
                tenant={this.props.navigatorStore.tenant.indexOf(".sharepoint.com") != -1 ? this.props.navigatorStore.tenant.replace(".sharepoint.com", "") : this.props.navigatorStore.tenant}
                token={this.props.navigatorStore.token}
                instance={this.props.navigatorStore.selectedEvent.instance}
                highlightColor={this.props.navigatorStore.highlightColor}
                display={this.props.navigatorStore.selectedEvent.displayType != undefined ? this.props.navigatorStore.selectedEvent.displayType : "Card view"}
                showPeriod={this.props.navigatorStore.selectedEvent.showPeriod}
                fontSlots={this.props.navigatorStore.fontSlots}
                numberOfCards={this.props.navigatorStore.selectedEvent.numberOfEvents}
                likesEnabled={this.props.navigatorStore.selectedEvent.enableLikes != undefined ? this.props.navigatorStore.selectedEvent.enableLikes : true}
                commentsEnabled={this.props.navigatorStore.selectedEvent.enableComments != undefined ? this.props.navigatorStore.selectedEvent.enableComments : true}
                isAdminPage={false}
                showDetailsViewInline={true}
                header={{
                  title: this.props.navigatorStore.selectedEvent.title,
                  headlineColor: this.props.navigatorStore.selectedEvent.headlineColor != undefined ? this.props.navigatorStore.selectedEvent.headlineColor : "#333333",
                  fontSize: this.props.navigatorStore.selectedEvent.fontSize != undefined ? this.props.navigatorStore.selectedEvent.fontSize : "24px",
                  fontWeight: this.props.navigatorStore.selectedEvent.fontWeight != undefined ? this.props.navigatorStore.selectedEvent.fontWeight : "regular",
                  textAlign: this.props.navigatorStore.selectedEvent.textAlign != undefined ? this.props.navigatorStore.selectedEvent.textAlign : "left"
                }}
                isNavigator={false}
                close={() => {
                  this.props.navigatorStore.selectedEvent = undefined;
                  this.props.navigatorStore.selectTopMenuItem(undefined);
                  document.body.style.overflowY = "auto";
                  document.body.style.height = "inherit";
                }}
                showFilter={this.props.navigatorStore.selectedEvent.showFilter}
                showPaging={this.props.navigatorStore.selectedEvent.showPaging != undefined ? this.props.navigatorStore.selectedEvent.showPaging : true}
                showTitle={true}
                showImage={true}
                showLikes={this.props.navigatorStore.selectedEvent.enableLikes != undefined ? this.props.navigatorStore.selectedEvent.enableLikes : true}
                showComments={this.props.navigatorStore.selectedEvent.enableComments != undefined ? this.props.navigatorStore.selectedEvent.enableComments : true}
                showCategories={this.props.navigatorStore.selectedEvent.showCategories != undefined ? this.props.navigatorStore.selectedEvent.showCategories : true}
                showTimespand={this.props.navigatorStore.selectedEvent.showTimespand != undefined ? this.props.navigatorStore.selectedEvent.showTimespand : true}
                showLocation={true}
                addMessage={this.props.navigatorStore.selectedEvent.addMessage != undefined ? this.props.navigatorStore.selectedEvent.addMessage : true}
                showDropShadow={this.props.navigatorStore.selectedEvent.showDropShadow != undefined ? this.props.navigatorStore.selectedEvent.showDropShadow : true}
                isTargetingAvailable={this.props.navigatorStore.selectedEvent.isTargetingAvailable != undefined ? this.props.navigatorStore.selectedEvent.isTargetingAvailable : true}
                backgroundColor={this.props.navigatorStore.selectedEvent.backgroundColor}
                textColor={this.props.navigatorStore.selectedEvent.textColor}
                dateBadgeBackgroundColor={this.props.navigatorStore.selectedEvent.dateBadgeBackgroundColor}
                dateBadgeTextColor={this.props.navigatorStore.selectedEvent.dateBadgeTextColor}
                borderColor={this.props.navigatorStore.selectedEvent.borderColor}
                selectedCategories={this.props.navigatorStore.selectedEvent.selectedCategories}
                shouldFilterByCategory={this.props.navigatorStore.selectedEvent.shouldFilterByCategory}
              />
            }
            {this.props.navigatorStore.navigator != undefined && this.state.instance && this.state.eventToOpenSettings &&
              <IAEvent
                environment={this.props.navigatorStore.environment}
                tenant={this.props.navigatorStore.tenant.indexOf(".sharepoint.com") != -1 ? this.props.navigatorStore.tenant.replace(".sharepoint.com", "") : this.props.navigatorStore.tenant}
                token={this.props.navigatorStore.token}
                highlightColor={this.props.navigatorStore.highlightColor}
                isAdminPage={false}
                isNavigator={true}
                openContentFromLink={this.state.eventToOpenSettings}
                instance={this.state.instance}
                numberOfCards={1}
              />
            }
          </div>
        </div>
      </div>
    );
  }



  public componentWillUnmount(): void {
    window.removeEventListener('popstate', () => this.openEventFromUrl());
  }
}


